import React, { useState, useEffect } from 'react';
import { PageHeader, Btn, Badge, Table, Modal } from '../../components/UI';
import { adminApi } from '../../utils/api';
import toast from 'react-hot-toast';

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [pwdModal, setPwdModal] = useState(null);
  const [extendModal, setExtendModal] = useState(null);
  const [newPwd, setNewPwd] = useState('');
  const [extendDays, setExtendDays] = useState(30);

  const load = async () => {
    setLoading(true);
    try { const { data } = await adminApi.get('/api/admin/users', { params: { search, status: statusFilter } }); if (data.success) setUsers(data.users); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, [search, statusFilter]);

  const changeStatus = async (id, action) => {
    if (!window.confirm(`${action} this user?`)) return;
    const endpoints = { suspend: `/api/admin/users/${id}/suspend`, block: `/api/admin/users/${id}/block`, activate: `/api/admin/users/${id}/extend` };
    const body = action === 'activate' ? { days: 0 } : {};
    const { data } = await adminApi.put(endpoints[action], body);
    if (data.success) { toast.success('Done!'); load(); } else toast.error(data.message);
  };

  const deleteUser = async (id) => {
    if (!window.confirm('Delete this user permanently?')) return;
    const { data } = await adminApi.delete(`/api/admin/users/${id}`);
    if (data.success) { toast.success('User deleted'); load(); } else toast.error(data.message);
  };

  const resetPwd = async () => {
    if (!newPwd.trim()) { toast.error('Enter password'); return; }
    const { data } = await adminApi.put(`/api/admin/users/${pwdModal.id}/reset-password`, { new_password: newPwd });
    if (data.success) { toast.success('Password reset! Share via WhatsApp.'); setPwdModal(null); setNewPwd(''); }
    else toast.error(data.message);
  };

  const extendPlan = async () => {
    const { data } = await adminApi.put(`/api/admin/users/${extendModal}/extend`, { days: extendDays });
    if (data.success) { toast.success(`Plan extended by ${extendDays} days`); setExtendModal(null); load(); }
    else toast.error(data.message);
  };

  return (
    <div>
      <PageHeader title="User Management" />
      <div style={{ display: 'flex', gap: 12, marginBottom: 20, flexWrap: 'wrap' }}>
        <input value={search} onChange={e => setSearch(e.target.value)} placeholder="🔍 Search name, email, phone..." style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 8, padding: '9px 14px', color: 'var(--text)', fontSize: 13, minWidth: 240 }} />
        <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 8, padding: '9px 14px', color: 'var(--text)', fontSize: 13 }}>
          <option value="">All Status</option>
          <option value="active">Active</option>
          <option value="pending">Pending</option>
          <option value="suspended">Suspended</option>
          <option value="blocked">Blocked</option>
        </select>
      </div>
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
        <Table loading={loading} emptyMsg="No users found"
          columns={[
            { key: 'name', label: 'Name / Company', render: (v, r) => <div><div style={{ fontWeight: 600 }}>{v}</div><div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{r.company_name}</div></div> },
            { key: 'email', label: 'Email / Phone', render: (v, r) => <div style={{ fontSize: 13 }}>{v}<br /><span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{r.phone}</span></div> },
            { key: 'plan_name', label: 'Plan', render: v => <Badge>{v || 'No Plan'}</Badge> },
            { key: 'status', label: 'Status', render: v => <Badge>{v}</Badge> },
            { key: 'currency', label: 'Currency', render: v => <span style={{ fontSize: 12 }}>{v || 'INR'}</span> },
            { key: 'plan_expiry_date', label: 'Expiry', render: v => <span style={{ fontSize: 12, color: v && new Date(v) < new Date() ? '#ff6b6b' : '#ffd700' }}>{v ? new Date(v).toLocaleDateString('en-IN') : '—'}</span> },
            { key: 'id', label: 'Actions', render: (v, r) => (
              <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                <button onClick={() => setExtendModal(v)} style={{ background: 'rgba(255,200,0,0.1)', color: '#ffd700', border: 'none', padding: '4px 8px', borderRadius: 5, fontSize: 10, cursor: 'pointer' }}>📅</button>
                <button onClick={() => setPwdModal({ id: v, name: r.name })} style={{ background: 'rgba(77,168,255,0.1)', color: '#4da8ff', border: 'none', padding: '4px 8px', borderRadius: 5, fontSize: 10, cursor: 'pointer' }}>🔑</button>
                {r.status === 'active' && <button onClick={() => changeStatus(v, 'suspend')} style={{ background: 'rgba(255,200,0,0.1)', color: '#ffd700', border: 'none', padding: '4px 8px', borderRadius: 5, fontSize: 10, cursor: 'pointer' }}>⏸</button>}
                {(r.status === 'suspended' || r.status === 'blocked') && <button onClick={() => changeStatus(v, 'activate')} style={{ background: 'rgba(0,231,76,0.1)', color: 'var(--green)', border: 'none', padding: '4px 8px', borderRadius: 5, fontSize: 10, cursor: 'pointer' }}>✅</button>}
                {r.status !== 'blocked' && <button onClick={() => changeStatus(v, 'block')} style={{ background: 'rgba(255,68,68,0.1)', color: '#ff6b6b', border: 'none', padding: '4px 8px', borderRadius: 5, fontSize: 10, cursor: 'pointer' }}>🚫</button>}
                <button onClick={() => deleteUser(v)} style={{ background: 'rgba(255,68,68,0.1)', color: '#ff6b6b', border: 'none', padding: '4px 8px', borderRadius: 5, fontSize: 10, cursor: 'pointer' }}>🗑</button>
              </div>
            )},
          ]}
          data={users}
        />
      </div>

      {/* Password Modal */}
      <Modal open={!!pwdModal} onClose={() => { setPwdModal(null); setNewPwd(''); }} title="🔑 Reset Password">
        <p style={{ color: 'var(--text-muted)', fontSize: 14, marginBottom: 16 }}>Set new password for <strong>{pwdModal?.name}</strong>. Remember to share via WhatsApp!</p>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 13, color: 'var(--text-secondary)', marginBottom: 6 }}>New Password *</label>
          <input type="text" value={newPwd} onChange={e => setNewPwd(e.target.value)} placeholder="Enter new password" style={{ width: '100%', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, padding: '10px 14px', color: 'var(--text)', fontSize: 14 }} />
        </div>
        <div style={{ display: 'flex', gap: 12 }}><Btn onClick={resetPwd} full>Reset & Save</Btn><Btn variant="outline" onClick={() => setPwdModal(null)} full>Cancel</Btn></div>
      </Modal>

      {/* Extend Modal */}
      <Modal open={!!extendModal} onClose={() => setExtendModal(null)} title="📅 Extend Plan">
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 13, color: 'var(--text-secondary)', marginBottom: 6 }}>Extend by (days)</label>
          <input type="number" value={extendDays} onChange={e => setExtendDays(e.target.value)} min="1" style={{ width: '100%', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 8, padding: '10px 14px', color: 'var(--text)', fontSize: 14 }} />
        </div>
        <div style={{ display: 'flex', gap: 12 }}><Btn onClick={extendPlan} full>Extend</Btn><Btn variant="outline" onClick={() => setExtendModal(null)} full>Cancel</Btn></div>
      </Modal>
    </div>
  );
}